import { render, staticRenderFns } from "./FormRicavo.vue?vue&type=template&id=0260d7d5&"
import script from "./FormRicavo.vue?vue&type=script&lang=js&"
export * from "./FormRicavo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports